import type { FC } from 'react'
import { classifyOutput } from './classifyOutput'
import { humanizeVariableName } from './variableLabel'
import styles from './CustomWorkflows.module.scss'
import { FileListOutput, FileOutput, HtmlOutput, JsonOutput, PrimitiveOutput, TextOutput } from './outputRenderers'
import { ChecklistOutput, EmailOutput, KeyValueOutput, MarkdownOutput, TableOutput } from './typedOutputRenderers'
import type { OutputKind, OutputRenderer, OutputTypeHint } from './outputTypes'

const OUTPUT_RENDERERS: Record<OutputKind, OutputRenderer> = {
  html: HtmlOutput,
  file: FileOutput,
  'file-list': FileListOutput,
  text: TextOutput,
  json: JsonOutput,
  number: PrimitiveOutput,
  boolean: PrimitiveOutput,
  empty: PrimitiveOutput,
  email: EmailOutput,
  markdown: MarkdownOutput,
  table: TableOutput,
  keyValue: KeyValueOutput,
  checklist: ChecklistOutput,
}

interface WorkflowOutputFieldProps {
  name: string
  value: unknown
  hint?: OutputTypeHint
}

export const WorkflowOutputField: FC<WorkflowOutputFieldProps> = ({ name, value, hint }) => {
  const output = classifyOutput(value, hint)
  const Renderer = OUTPUT_RENDERERS[output.kind]
  return (
    <div className={styles.outputField}>
      <div className={styles.outputLabel}>{humanizeVariableName(name)}</div>
      <Renderer output={output} label={name} />
    </div>
  )
}
